import React from 'react';
import { Trans } from 'lingui-react';

import Hand from '../../../../assets/images/hand.svg';
import Comment from '../../../../assets/images/commentIconRecommend.svg';

export const Recommendation = props => {
  let recommendationRows = null;
  recommendationRows = props.recommendations.map((recommendation, index) => {
    let parser = new DOMParser();
    let content = parser.parseFromString(recommendation.recommendation, 'text/html');
    return (
      <div key={index} className="spacing-assessment-component">
        <div className="container">
          <div className="row pl-md-5">
            <div className="col-md-4 left-column">
              <p className="title-recommendation"><Trans id="RECOMMENDATION #" /> {index + 1}</p>
              <p className="category-recomendation"><Trans id="CATEGORY:" /><span>&nbsp;{recommendation.category.toUpperCase()}</span></p>
              <p className="category-recomendation"><Trans id="> TOPIC:" /><span>&nbsp;{recommendation.topic.toUpperCase()}</span></p>
            </div>
            <div className="col-md-8 right-column no-padding">
              <div className="advice-title-container">
                <img alt="" src={Hand} />
                <p className="advice-title">
                  <span dangerouslySetInnerHTML={{ __html: content.body.textContent }}></span>
                </p>
              </div>
              {
                recommendation.comment
                  ? <div className="advice-title-container border-top">
                    <img className="img-comment" alt="" src={Comment} />
                    <p className="comment-title">
                      <b><Trans id="Your Comment:"/> </b>{recommendation.comment}
                    </p>
                  </div>
                  : ''
              }
            </div>
          </div>
        </div>
      </div>
    );
  });
  if (recommendationRows.length === 0) {
    recommendationRows = (
      <div className="spacing-assessment-component">
        <div className="container">
          <div className="row">
            <div className="col-md-4 left-column">
              <p className="title-recommendation"><Trans id="RECOMMENDATION" /></p>
            </div>
            <div className="col-md-8 right-column">
              <div className="advice-title-container">
                <img alt="" src={Hand} />
                <p className="advice-title">
                  <Trans id="We have no recommendations for you!" />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="container">
      <div className="row spacing-assessment-component">
        <div className="col-12">
          <h6 className="assessment-content">2. <Trans id="recommendations" /></h6>
        </div>
        <div className="col-12">
          <p>
            <Trans id="Based on the score achieved for the different topics, we recommend implementing some measures to improve your company's IT security." />
          </p>
          <p><Trans id="The following recommended measures are sorted by descending priority:" /></p>
          <br />
        </div>
      </div>
      {recommendationRows}
      <div className="blank"></div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/screens/AssessmentReport/components/Recommendation/Recommendation.js